import { createFileRoute } from "@tanstack/react-router";
import { getReport } from "@/features/reports/records";
import { ReportPage } from "@/features/reports";
import {
  CommunityPageLoading,
  CommunityPageError,
} from "@/features/community/navigation";

export const Route = createFileRoute(
  "/_site/unlisted/$coworld_/reports/$reportSlug",
)({
  loader: ({ params, abortController }) =>
    getReport({
      data: { slug: params.reportSlug },
      signal: abortController.signal,
    }),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData ? `${loaderData.title} · Softmax` : "Softmax" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  pendingComponent: () => <CommunityPageLoading title="Report" />,
  errorComponent: ({ error, reset }) => (
    <CommunityPageError error={error} retry={reset} />
  ),
  component: () => <ReportPage report={Route.useLoaderData()} />,
});
